import React from 'react';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-6 ${className}`}>
      {/* Hierarchy was inverted: the title rendered at 14px and the description
          at 12px, so an empty state's headline was SMALLER than an ordinary room
          name (15px) in the list it replaces. An empty state is the first thing a
          new project or room shows, so it should read as the primary thing on
          screen. 17px is the app's title tier — the earlier 20px outranked every
          real card title, so an empty room shouted louder than a full one. */}
      <div className="w-16 h-16 rounded-full bg-[var(--bg-surface-alt)] flex items-center justify-center mb-5">
        <Icon size={28} className="text-[var(--text-tertiary)]" aria-hidden="true" />
      </div>
      <h3 className="text-[17px] leading-[22px] font-semibold text-[var(--text-primary)] tracking-[-0.01em] mb-1.5 text-center">{title}</h3>
      {description && (
        <p className="text-[15px] leading-snug text-[var(--text-secondary)] text-center max-w-[280px]">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
